import { render } from "./Step_1.vue?vue&type=template&id=0fd566b9"
import script from "./Step_1.vue?vue&type=script&lang=js"
export * from "./Step_1.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__